import type { Environment, EnvironmentWithChina } from '../App'

// Maps China-specific environments to their base equivalents so they can be
// passed to downstream SDKs/components that only understand the base envs.
export const normalizeEnvironment = (
  env: EnvironmentWithChina,
): Environment => {
  switch (env) {
    case 'cn_tst':
      return 'tst'
    case 'cn_prd':
      return 'prd'
    default:
      return env
  }
}
